var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('element-loading',{attrs:{"active":_vm.pageLoading,"is-full-screen":true,"background-color":"white"}},[_c('img',{attrs:{"src":require('./assets/svg/carnival-loader.svg'),"width":"450","height":"180"}})]),_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }